//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.HoleBossSetList.js";
import "../no/SelectTaggedObject.js";
import "../CAM/CAM.ThreadedBossSetList.js";
import "../CAM/CAM.ThreadedHoleSetList.js";
import "../no/SelectObject.js";
import "../no/ObjectList.js";
let d=[[[1,"BossList",0,"CAM.HoleBossSetList",0],[0,"DepthLimit",1,1],[0,"FormAndPitch",1,0],[0,"HoleBossGeomType",1,0],[1,"HoleList",0,"CAM.HoleBossSetList",0],[0,"Optimization",1,0],[0,"Pitch",1,0],[0,"Rotation",1,0],[1,"Selection",0,"SelectTaggedObject",0],[1,"ThreadedBossList",0,"CAM.ThreadedBossSetList",0],[1,"ThreadedHoleList",0,"CAM.ThreadedHoleSetList",0]],[[["type","formCustom"],"GetForm",{},0,0],[["type","formCustom"],"SetForm",{},2,0],[["entities","tapDrillSize","depth","toolAxis","majorDiameter","minorDiameter","lengh","size","radialEngage","pitch","rotation","form","formUserDefined","tableStandard","depthLimit"],"CreateThreadedHoleBuilder",{R_:{threadedHoleSetBuilder:"CAM.ThreadedHoleSet"}},15,0],[["entities","diameter","height","toolAxis","majorDiameter","minorDiameter","lengh","size","pitch","rotation","form","formUserDefined"],"CreateThreadedBossBuilder",{R_:{threadedBossSetBuilder:"CAM.ThreadedBossSet"}},12,0],[["entities","diameter","depth","toolAxis","depthLimit"],"CreateHoleBossBuilder",{R_:{holeBossSetBuilder:"CAM.HoleBossSet"}},5,0],[[],"ReorderList",{},0,0],[[],"GetCenterHoleGeometry",{R_:{centerHoleBuilder:"CAM.FBM.MachiningFeatureGeometry"}},0,0],[[],"GetChamferHoleGeometry",{R_:{chamferHoleBuilder:"CAM.FBM.MachiningFeatureGeometry"}},0,0]],[]];
SPLM.CAM.HoleBossGeom = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.HoleBossGeom";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.HoleBossGeom.HoleBossTypes = Object.freeze({
    "Hole" : "Hole", "Boss" : "Boss", "ThreadedHole" : "ThreadedHole", "ThreadedBoss" : "ThreadedBoss", "CenterHole" : "CenterHole", "ChamferHole" : "ChamferHole"});

SPLM.CAM.HoleBossGeom.FormPitchTypes = Object.freeze({
    "Specify" : "Specify", "FromTable" : "FromTable", "FromTool" : "FromTool", "FromModel" : "FromModel"});

SPLM.CAM.HoleBossGeom.RotationTypes = Object.freeze({
    "RightHand" : "RightHand", "LeftHand" : "LeftHand"});

SPLM.CAM.HoleBossGeom.DepthLimitTypes = Object.freeze({
    "Through" : "Through", "Blind" : "Blind", "Unknown" : "Unknown"});

SPLM.CAM.HoleBossGeom.FormTypes = Object.freeze({
    "Unified" : "Unified", "Metric" : "Metric", "Trapezoidal" : "Trapezoidal", "Acme" : "Acme", "StubAcme" : "StubAcme", "Lowernherz" : "Lowernherz", "Buttress" : "Buttress", "SparkPlug" : "SparkPlug", "Npt" : "Npt", "HoseCoupling" : "HoseCoupling", "FireHose" : "FireHose", "Unj" : "Unj", "Nps" : "Nps", "Bsp" : "Bsp", "Bstp" : "Bstp", "Helicoil" : "Helicoil", "Ns" : "Ns", "UserDefined" : "UserDefined"});

SPLM.CAM.HoleBossGeom.OptimizationTypes = Object.freeze({
    "Closest" : "Closest", "ShortestPath" : "ShortestPath"});

export default SPLM;